import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26a8c98c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import {ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["toggleMobileMenuDisplay"],
  setup(__props, { emit }: { emit: ({
  (e: 'toggleMobileMenuDisplay'): void
}), expose: any, slots: any, attrs: any }) {

const menuSelected = ref(false);



const toggleMobileMenuDisplay = () => {
  menuSelected.value = !menuSelected.value;
  emit('toggleMobileMenuDisplay');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "hamburger-icon",
    onClick: toggleMobileMenuDisplay
  }, _hoisted_2))
}
}

})